import { render, staticRenderFns } from "./PageOpportunityGoNoGo.vue?vue&type=template&id=8fa489a0"
import script from "./PageOpportunityGoNoGo.vue?vue&type=script&lang=js"
export * from "./PageOpportunityGoNoGo.vue?vue&type=script&lang=js"
import style0 from "./PageOpportunityGoNoGo.vue?vue&type=style&index=0&id=8fa489a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports